export * from './action.service';
import { ActionService } from './action.service';
export * from './campaigns.service';
import { CampaignsService } from './campaigns.service';
export * from './characters.service';
import { CharactersService } from './characters.service';
export * from './events.service';
import { EventsService } from './events.service';
export * from './invites.service';
import { InvitesService } from './invites.service';
export * from './players.service';
import { PlayersService } from './players.service';
export const APIS = [ActionService, CampaignsService, CharactersService, EventsService, InvitesService, PlayersService];
